import React from "react";
import { FiTruck, FiClock } from "react-icons/fi";
import { MdPayment } from "react-icons/md";
import { GiSmartphone } from "react-icons/gi";
import { BiSearchAlt } from "react-icons/bi";

const SellSection = ({ isDarkMode }) => {
  const cards = [
    {
      title: "How Tap2Cash is Different?",
      description:
        "Tap2Cash isn't just another mobile resale platform—it's a game-changer! We make selling your used smartphone, tablet, or smartwatch effortless with a smooth, transparent, and hassle-free process. Enjoy instant cash, free doorstep pickup, and zero hidden charges.",
      icon: <GiSmartphone className="text-lg" />,
    },
    {
      title: "Sell Any Model with Ease",
      description:
        "Whether it's a second-hand mobile, an outdated iPhone, or an old Nokia, Tap2Cash accepts all used smartphones, tablets, and smartwatches. Get a hassle-free and secure mobile resale experience with the best market value.",
      icon: <GiSmartphone className="text-lg" />,
    },
    {
      title: "Instant Payment, Every Time!",
      description:
        "With Tap2Cash, there's no waiting, no delays—just instant cash for your old phone before pickup! Receive payment via bank transfer or digital wallets for a seamless experience.",
      icon: <MdPayment className="text-lg" />,
    },
    {
      title: "Free Doorstep Pickup",
      description:
        "Selling your used smartphone, tablet, or smartwatch is now completely hassle-free with free doorstep pickup. No hidden charges—just pure convenience!",
      icon: <FiTruck className="text-lg" />,
    },
  ];

  const steps = [
    {
      number: "1",
      title: "Visit the Tap2Cash Website",
      description:
        "Enter details of your second-hand mobile (brand, model, and condition) to get an instant price.",
    },
    {
      number: "2",
      title: "Schedule a Pickup",
      description:
        "Select a date and time that suits you, and our team will arrive at your home or workplace for collection.",
    },
    {
      number: "3",
      title: "Instant Payment, On-the-Spot",
      description:
        "Our technician will verify your device condition, and you'll receive instant cash via bank transfer or digital wallet.",
    },
  ];

  return (
    <section className="mb-6">
      {/* Header */}
      <div className="mb-3">
        <h1 className="mb-1 text-lg font-bold text-gray-800 dark:text-gray-100 md:text-xl ">
          Sell Old Mobile Phones Online
        </h1>
        <p
          className={`text-xs ${isDarkMode ? "text-gray-400" : "text-gray-600"}`}
        >
          Do you want to let go of your old device and turn it into instant
          cash? Tap2Cash enables you to do that quickly, easily, and profitably.
          Get the best price for old phones along with top-notch service.
        </p>
      </div>

      {/* 2x2 Cards Grid */}
      <div className="grid grid-cols-1 gap-2 mb-4 md:grid-cols-2">
        {cards.map((card, index) => (
          <div
            key={index}
            className={`p-3 rounded-lg transition-all hover:shadow-md ${
              isDarkMode
                ? "bg-gray-800 hover:bg-gray-750"
                : "bg-white hover:shadow-lg border border-gray-100"
            }`}
          >
            <div className="flex items-start gap-2">
              {/* Green Icon Container */}
              <div
                className={`w-7 h-7 rounded-lg flex items-center justify-center shrink-0 mt-0.5 ${
                  isDarkMode
                    ? "bg-green-600/20 text-green-400"
                    : "bg-green-100 text-green-600"
                }`}
              >
                {card.icon}
              </div>
              <div className="flex-1">
                <h2
                  className={`text-xs font-bold mb-1 ${
                    isDarkMode ? "text-white" : "text-gray-800"
                  }`}
                >
                  {card.title}
                </h2>
                <p
                  className={`text-[10px] leading-relaxed ${
                    isDarkMode ? "text-gray-400" : "text-gray-600"
                  }`}
                >
                  {card.description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Steps Section */}
      <div>
        <h2 className="mb-2 text-sm font-bold text-gray-800 dark:text-gray-100 ">
          Here's How It Works:
        </h2>

        <div className="space-y-2">
          {steps.map((step, index) => (
            <div key={index} className="flex items-start gap-2">
              {/* Green Step Number */}
              <div
                className={`w-5 h-5 rounded-full flex items-center justify-center text-[9px] font-bold shrink-0 mt-0.5 ${
                  isDarkMode
                    ? "bg-green-600/20 text-green-400"
                    : "bg-green-100 text-green-600"
                }`}
              >
                {step.number}
              </div>
              <div>
                <h3
                  className={`text-xs font-bold mb-0.5 ${
                    isDarkMode ? "text-white" : "text-gray-800"
                  }`}
                >
                  {step.title}
                </h3>
                <p
                  className={`text-[10px] ${
                    isDarkMode ? "text-gray-400" : "text-gray-500"
                  }`}
                >
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SellSection;
